import { render, staticRenderFns } from "./addProductModel.vue?vue&type=template&id=b800e7ae&scoped=true"
import script from "./addProductModel.vue?vue&type=script&lang=js"
export * from "./addProductModel.vue?vue&type=script&lang=js"
import style0 from "./addProductModel.vue?vue&type=style&index=0&id=b800e7ae&prod&scoped=true&lang=css"
import style1 from "./addProductModel.vue?vue&type=style&index=1&id=b800e7ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b800e7ae",
  null
  
)

export default component.exports